import { TabPanel, Tabs } from "@apex/component-library";
import { Box, Tab, TabList, TabPanels, Text } from "@chakra-ui/react";
import { Formik, FormikConfig, FormikHelpers, FormikProps } from "formik";
import { withFormikDevtools } from "formik-devtools-extension";
import { useEffect, useState } from "react";

import useGetRequirements from "../../../api/useGetRequirements";
import { getErrorText } from "../auxUtils";
import { maxTableWidth } from "../constants";
import RequirementsAndActivityForm from "./form";
import requirementsAndActivityFormSchema from "./formValidations";
import SummariesTable from "./SummariesTable";
import TradeDetailsTable from "./TradeDetailsTable";
import { RequirementsAndActivityFormValues } from "./types";

interface RequirementsAndActivityProps {
  accountId: string;
  processDate: string;
}

const RequirementsAndActivity = ({
  accountId,
  processDate,
}: RequirementsAndActivityProps) => {
  const [fromProcessDate, setFromProcessDate] = useState<string | Date>(
    processDate
  );
  const [toProcessDate, setToProcessDate] = useState<string | Date>(
    processDate
  );
  const [requirementType, setRequirementType] = useState<string | undefined>(
    ""
  );

  const {
    data: requirementsData,
    isLoading: requirementsDataLoading,
    error: requirementsDataError,
    refetch,
    isFetching,
  } = useGetRequirements(
    accountId,
    fromProcessDate,
    toProcessDate,
    requirementType
  );

  useEffect(() => {
    refetch();
  }, [refetch]);

  const formikConfig: FormikConfig<RequirementsAndActivityFormValues> = {
    onSubmit: (
      values: RequirementsAndActivityFormValues,
      formikHelpers: FormikHelpers<RequirementsAndActivityFormValues>
    ) => {
      setFromProcessDate(values.fromProcessDate);
      setToProcessDate(values.toProcessDate);
      setRequirementType(values.requirementType);
      refetch();
    },
    initialValues: requirementsAndActivityFormSchema.cast({
      fromProcessDate: processDate,
      toProcessDate: processDate,
    }) as RequirementsAndActivityFormValues,
    validationSchema: requirementsAndActivityFormSchema,
    validateOnMount: true,
  };

  return (
    <>
      <Formik {...formikConfig}>
        {(formikProps: FormikProps<RequirementsAndActivityFormValues>) => {
          withFormikDevtools(formikProps);
          return (
            <Box mb={2}>
              <RequirementsAndActivityForm isFetching={isFetching} />
            </Box>
          );
        }}
      </Formik>
      {requirementsDataError && (
        <Text data-testid="requirements-error">
          {getErrorText(requirementsDataError)}
        </Text>
      )}
      {!requirementsDataError && (
        <Tabs variant="enclosed" height="100%">
          <TabList>
            <Tab>View By Class</Tab>
            <Tab>Trade Details</Tab>
          </TabList>
          <TabPanels height="100%">
            <TabPanel paddingBottom={5}>
              <Box maxW={maxTableWidth}>
                <SummariesTable
                  data={requirementsData}
                  isLoading={requirementsDataLoading}
                />
              </Box>
            </TabPanel>
            <TabPanel height="100%">
              <TradeDetailsTable
                data={requirementsData}
                isLoading={requirementsDataLoading}
              />
            </TabPanel>
          </TabPanels>
        </Tabs>
      )}
    </>
  );
};

export default RequirementsAndActivity;
